module.exports = __webpack_public_path__ + "img/baoming.01f5b2d8.png";